export var DEFAULT_LOCALE_STATE = {
  locale: 'en',
  messages: {}
};